<app-bulk-vehicle-details></app-bulk-vehicle-details>